import accommodation from './accommodation.json';

export default accommodation.filter(x=>x.id <= 2)